import React, { CSSProperties } from "react";
import { IElTextState, IETextProps } from "../Interfaces";

class TextEl<
    P extends HTMLElement,
    S extends IElTextState
> extends React.Component<IETextProps<P>, S> {
    __setStyle(styles: CSSProperties) {
        const mergedStyles = { ...this.props.style, ...styles };
        return mergedStyles;
    }

    __getFontUnit(): string {
        if (this.props.Brand) {
            return this.props.Brand.fontUnit;
        } else {
            return "px";
        }
    }

    __unitSize(value: number): string {
        return value + this.__getFontUnit();
    }
}

export { TextEl };
